(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('infection-primary-access', {
            parent: 'entity',
            url: '/infection-primary-access',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Infection Primary Accesses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-accesses.html',
                    controller: 'InfectionPrimaryAccessController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('infection-primary-access-detail', {
            parent: 'entity',
            url: '/infection-primary-access/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'InfectionPrimaryAccess'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-access-detail.html',
                    controller: 'InfectionPrimaryAccessDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InfectionPrimaryAccess', function($stateParams, InfectionPrimaryAccess) {
                    return InfectionPrimaryAccess.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'infection-primary-access',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('infection-primary-access-detail.edit', {
            parent: 'infection-primary-access-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-access-dialog.html',
                    controller: 'InfectionPrimaryAccessDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfectionPrimaryAccess', function(InfectionPrimaryAccess) {
                            return InfectionPrimaryAccess.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('infection-primary-access.new', {
            parent: 'infection-primary-access',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-access-dialog.html',
                    controller: 'InfectionPrimaryAccessDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('infection-primary-access', null, { reload: 'infection-primary-access' });
                }, function() {
                    $state.go('infection-primary-access');
                });
            }]
        })
        .state('infection-primary-access.edit', {
            parent: 'infection-primary-access',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-access-dialog.html',
                    controller: 'InfectionPrimaryAccessDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfectionPrimaryAccess', function(InfectionPrimaryAccess) {
                            return InfectionPrimaryAccess.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('infection-primary-access', null, { reload: 'infection-primary-access' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('infection-primary-access.delete', {
            parent: 'infection-primary-access',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-access-delete-dialog.html',
                    controller: 'InfectionPrimaryAccessDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InfectionPrimaryAccess', function(InfectionPrimaryAccess) {
                            return InfectionPrimaryAccess.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('infection-primary-access', null, { reload: 'infection-primary-access' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
